module.exports = __webpack_public_path__ + "img/wecode.197e0fd1.png";